import getCurrentRoute from '../utils/get-current-route';
var getRouteName = function (routes) {
    if (routes === void 0) { routes = []; }
    var _a = (getCurrentRoute(location.pathname, routes) || {}).name, routeName = _a === void 0 ? 'unknown' : _a;
    return routeName;
};
export default getRouteName;
//# sourceMappingURL=get-route-name.js.map